import React from 'react';
import { ModuleData } from '../data/module1';
interface PrintLayoutProps {
  moduleData: ModuleData;
  firstName: string;
  lastName: string;
  signatureDataUrl: string;
}
export function PrintLayout({
  moduleData,
  firstName,
  lastName,
  signatureDataUrl
}: PrintLayoutProps) {
  const date = new Date().toLocaleDateString('de-DE');
  return <div className="hidden print:block print:bg-white print:text-black print:p-8 max-w-4xl mx-auto" data-id="element-120">
      {/* Header */}
      <div className="flex justify-between items-start border-b-2 border-gray-800 pb-6 mb-8" data-id="element-121">
        <div data-id="element-122">
          <h1 className="text-2xl font-bold mb-2" data-id="element-123">
            Dokumentation: Arbeitsunterweisung
          </h1>
          <h2 className="text-xl text-gray-700" data-id="element-124">{moduleData.title}</h2>
        </div>
        <img src="https://cdn.magicpatterns.com/uploads/8ecn9exgjkQqt4cTmAm7H4/Logo.png" alt="INTIGOO Logo" className="h-10 object-contain" data-id="element-125" />
      </div>

      {/* Meta Info */}
      <div className="grid grid-cols-2 gap-4 mb-8 text-sm border border-gray-300 p-4 rounded" data-id="element-126">
        <div data-id="element-127">
          <p data-id="element-128">
            <span className="font-bold" data-id="element-129">Mitarbeiter:</span> {firstName}{' '}
            {lastName}
          </p>
          <p data-id="element-130">
            <span className="font-bold" data-id="element-131">Datum:</span> {date}
          </p>
        </div>
        <div data-id="element-132">
          <p data-id="element-133">
            <span className="font-bold" data-id="element-134">Verantwortlicher:</span>{' '}
            {moduleData.responsible}
          </p>
          <p data-id="element-135">
            <span className="font-bold" data-id="element-136">Bereich:</span> {moduleData.department}
          </p>
          <p data-id="element-137">
            <span className="font-bold" data-id="element-138">Brandschutzhelfer:</span> Louis Surmann
          </p>
          <p data-id="element-139">
            <span className="font-bold" data-id="element-140">Ersthelfer:</span> Manuel Stertenbrink
          </p>
        </div>
      </div>

      {/* Content Sections */}
      <div className="space-y-10 mb-12" data-id="element-141">
        {moduleData.sections.map(section => <div key={section.id} className="print-section" data-id="element-142">
            <h3 className="text-xl font-bold border-b-2 border-gray-800 pb-2 mb-4 break-after-avoid" data-id="element-143">
              {section.title}
            </h3>

            {/* Basic Info (Content, Hazards, Measures) */}
            <div className="space-y-4 mb-6" data-id="element-144">
              {section.content && section.content.length > 0 && <div style={{
            pageBreakInside: 'avoid'
          }} data-id="element-145">
                  <h4 className="font-bold text-sm mb-1" data-id="element-146">
                    Tätigkeiten / Übersicht:
                  </h4>
                  <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-147">
                    {section.content.map((item, idx) => <li key={idx} data-id="element-148">{item}</li>)}
                  </ul>
                </div>}

              {section.hazards && section.hazards.length > 0 && <div style={{
            pageBreakInside: 'avoid'
          }} data-id="element-149">
                  <h4 className="font-bold text-sm mb-1 text-red-800" data-id="element-150">
                    Gefährdungen:
                  </h4>
                  <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-151">
                    {section.hazards.map((hazard, idx) => <li key={idx} data-id="element-152">{hazard}</li>)}
                  </ul>
                </div>}

              {section.measures && section.measures.length > 0 && <div style={{
            pageBreakInside: 'avoid'
          }} data-id="element-153">
                  <h4 className="font-bold text-sm mb-1 text-green-800" data-id="element-154">
                    Schutzmaßnahmen:
                  </h4>
                  <ul className="list-disc pl-5 text-sm space-y-1" data-id="element-155">
                    {section.measures.map((measure, idx) => <li key={idx} data-id="element-156">{measure}</li>)}
                  </ul>
                </div>}
            </div>

            {/* Guides (Step-by-Step) */}
            {section.guides && section.guides.length > 0 && <div className="space-y-6 mb-6" data-id="element-157">
                {section.guides.map((guide, gIdx) => <div key={gIdx} className="border border-gray-200 rounded p-4" style={{
            pageBreakInside: 'avoid'
          }} data-id="element-158">
                    <h4 className="font-bold text-base mb-3 bg-gray-50 p-2 rounded" data-id="element-159">
                      Anleitung: {guide.title}
                    </h4>

                    {/* Steps */}
                    <div className="space-y-3 mb-4" data-id="element-160">
                      {guide.steps.map((step, sIdx) => <div key={sIdx} className="flex items-start gap-3 text-sm" data-id="element-161">
                          <div className="font-bold text-gray-500 w-5 flex-shrink-0" data-id="element-162">
                            {sIdx + 1}.
                          </div>
                          <div className="flex-1" data-id="element-163">
                            <span className="font-bold" data-id="element-164">{step.step}: </span>
                            <span data-id="element-165">{step.detail}</span>
                          </div>
                          {step.imageUrl && <img src={step.imageUrl} alt={step.step} className="w-24 h-16 object-cover rounded border border-gray-200 flex-shrink-0" data-id="element-166" />}
                        </div>)}
                    </div>

                    {/* Dos and Don'ts */}
                    <div className="grid grid-cols-2 gap-4 text-sm mt-4 pt-4 border-t border-gray-100" data-id="element-167">
                      <div data-id="element-168">
                        <h5 className="font-bold text-green-800 mb-2" data-id="element-169">
                          Richtig (Do's):
                        </h5>
                        <ul className="space-y-1" data-id="element-170">
                          {guide.dos.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-171">
                              <span className="text-green-600 mr-2" data-id="element-172">✓</span>
                              <span data-id="element-173">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                      <div data-id="element-174">
                        <h5 className="font-bold text-red-800 mb-2" data-id="element-175">
                          Falsch (Don'ts):
                        </h5>
                        <ul className="space-y-1" data-id="element-176">
                          {guide.donts.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-177">
                              <span className="text-red-600 mr-2" data-id="element-178">✗</span>
                              <span data-id="element-179">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </div>
                  </div>)}
              </div>}

            {/* Quiz */}
            {section.quiz && section.quiz.length > 0 && <div className="bg-gray-50 border border-gray-200 rounded p-4" style={{
          pageBreakInside: 'avoid'
        }} data-id="element-180">
                <h4 className="font-bold text-base mb-3 border-b border-gray-200 pb-2" data-id="element-181">
                  Wissens-Check
                </h4>
                <div className="space-y-4" data-id="element-182">
                  {section.quiz.map((q, qIdx) => <div key={qIdx} className="text-sm" style={{
              pageBreakInside: 'avoid'
            }} data-id="element-183">
                      <p className="font-bold mb-2" data-id="element-184">
                        {qIdx + 1}. {q.question}
                      </p>
                      <div className="pl-4 space-y-1 mb-2" data-id="element-185">
                        {q.options.map((opt, oIdx) => {
                  const isCorrect = oIdx === q.correctIndex;
                  const letter = String.fromCharCode(97 + oIdx); // a, b, c, d
                  return <div key={oIdx} className={`flex items-start ${isCorrect ? 'font-bold text-green-800' : 'text-gray-600'}`} data-id="element-186">
                              <span className="w-6" data-id="element-187">{letter})</span>
                              <span data-id="element-188">{opt}</span>
                              {isCorrect && <span className="ml-2 text-green-600" data-id="element-189">
                                  ✓ (Korrekt)
                                </span>}
                            </div>;
                })}
                      </div>
                      <p className="pl-4 italic text-gray-600 text-xs border-l-2 border-gray-300 ml-1 py-1" data-id="element-190">
                        → {q.explanation}
                      </p>
                    </div>)}
                </div>
              </div>}
          </div>)}
      </div>

      {/* Signature Block */}
      <div className="mt-12 pt-8 border-t-2 border-gray-800" style={{
      pageBreakInside: 'avoid'
    }} data-id="element-191">
        <h3 className="text-lg font-bold mb-4" data-id="element-192">Bestätigung</h3>
        <p className="text-sm mb-8" data-id="element-193">
          Hiermit bestätige ich,{' '}
          <strong data-id="element-194">
            {firstName} {lastName}
          </strong>
          , dass ich alle Inhalte der Schulung vollständig gelesen und
          verstanden habe. Ich verpflichte mich, die beschriebenen
          Schutzmaßnahmen einzuhalten.
        </p>

        <div className="flex justify-between items-end mt-12" data-id="element-195">
          <div className="w-1/3" data-id="element-196">
            <p className="text-sm font-bold mb-1" data-id="element-197">Datum:</p>
            <p className="text-sm border-b border-black pb-1" data-id="element-198">{date}</p>
          </div>
          <div className="w-1/2 relative" data-id="element-199">
            {signatureDataUrl && <img src={signatureDataUrl} alt="Unterschrift" className="mb-2 max-h-20 mx-auto" data-id="element-200" />}
            <div className="border-t border-black pt-2" data-id="element-201">
              <p className="text-sm text-center" data-id="element-202">
                Unterschrift Teilnehmer ({firstName} {lastName})
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}